module.exports = {
  PRIVATE: 'PRIVATE',
  ORGANIZATION: 'ORGANIZATION',
  MEMBERS: 'MEMBERS'
};
